<template>
  <section class="ugc-tint-image-control">
    <div ref="colorContainer" class="ugc-tint-image-control-input-wrapper">
      <input
        v-model="colorValue"
        value="#fff"
        ref="color_input"
        class="jscolor ugc-tint-image-control-input"
      />
    </div>
  </section>
</template>
<script>
import { fabric } from "@vfdp-customs/customs-fabric";
import BaseUgcTool from "../BaseUgcTool";
import jscolor from "@/libs/jscolor.js";

export default {
  extends: BaseUgcTool,
  name: "UgcTintImageControl",
  data() {
    return {
      fabricCanvas: this.$store.state.ugc.stateManager.canvas,
      colorValue: "",
      controlName: "tint"
    };
  },
  watch: {
    colorValue: function() {
      const filter = new fabric.Image.filters.BlendColor({
        color: this.colorValue,
        mode: "overlay",
        name: this.controlName
      });
      const img = this.fabricCanvas.getObjects("image")[0];
      // reset filters so it isn't apply multiple times
      //remove one specific filter
      const index = img.filters.findIndex(filter => filter.name === this.controlName);
      if (index >= 0) {
        img.filters.splice(index, 1);
      }
      //apply the filter
      img.filters.push(filter);
      img.applyFilters();
      this.fabricCanvas.renderAll();
    }
  },
  methods: {
    setColorPickerOptions() {
      const { clientWidth, clientHeight } = this.$refs.colorContainer;
      this.$refs.color_input.jscolor.width = clientWidth - 56;
      this.$refs.color_input.jscolor.height = clientHeight;
      this.$refs.color_input.jscolor.shadow = false;
      this.$refs.color_input.jscolor.borderWidth = "0";
      this.$refs.color_input.jscolor.borderRadius = "0";
      this.$refs.color_input.jscolor.backgroundColor = "transparent";
      if (this.$store.state.utils.configuration.enableNewUgcModal) {
        this.$refs.color_input.jscolor.insetWidth = 1;
        this.$refs.color_input.jscolor.insetColor = '#ccc';
      } else {
        this.$refs.color_input.jscolor.insetWidth = "0";
      }
      this.$refs.color_input.jscolor.onFineChange = () => {
        this.setColorValue();
      };
    },
    setColorValue() {
      this.colorValue = this.$refs.color_input.jscolor.toString(
        this.$refs.color_input.jscolor.rgb
      );
    },
    setPreviousColor() {
      const img = this.fabricCanvas.getObjects()[0];
      if (img.filters && img.filters.length > 0) {
        const index = img.filters
          .map(filter => filter.name)
          .indexOf(this.controlName);
        if (index > -1) {
          const color = img.filters[index].color;
          this.$refs.color_input.value = "#" + color;
        } else if (img.filters[0] && img.filters[0].type === "BlendColor") {
          const color = img.filters[0].color;
          this.$refs.color_input.value = "#" + color;
        }
      }
    }
  },
  mounted() {
    this.setPreviousColor();
    window.jscolor.installByClassName("jscolor");
    this.setColorPickerOptions();
    this.$refs.color_input.jscolor.show();
  },
  beforeDestroy() {
    this.$refs.color_input.jscolor.hide();
  }
};
</script>
